import ko from 'knockout';

var dvDummy = {
    componentName: 'dummy',
    component: {
        viewModel: function() {
            this.text = ko.observable("");
        },
        template: '<div text="text: text "></div>',
    }
};

dvDummy.model = function () {
    var m = this;
    m.componentName = ko.observable(dvDummy.componentName);
    m.boundNameProperty = ko.observable(m.componentName());
    m.boundShowProperty = ko.observable(false);
    //m.text = ko.observable("Loading Component...");
    m.text = ko.observable("");
    m.show = function show() {
        m.boundShowProperty(true);
    };
    m.hide = function hide() {
        m.boundShowProperty(false);
    };
};
dvDummy.register = function () {
    if (!ko.components.isRegistered(dvDummy.componentName)) {
        ko.components.register(dvDummy.componentName, dvDummy.component);
        return true;    //registered.
    }
    return false;    //already registered.
};

//Make the dummy component globally accessible.
dvDummy.register();

export default dvDummy;
